import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { RebateDocumentView, SHMOKH_NAME } from './rebate-document-view';
import { useRebateDocumentData } from './use-rebate-document-data';

/**
 * Route-connected entry point: /rebate-cancellation-print?bankId=<id>&commodityType=Local|International
 * Renders the "Cancellation Form" letter: cancellation fees paid to Al Shmokh,
 * with an extra "Total Deals" column counting the cancelled orders in the period.
 */
export const RebateCancellationPrint = (props: RouteComponentProps) => {
  const { language, bankName, accountNumber, referenceNo, date, periodLabel, currency, amount, totalDeals } =
    useRebateDocumentData('cancellation');

  return (
    <RebateDocumentView
      language={language}
      docType="cancellation"
      referenceNo={referenceNo}
      date={date}
      recipientName={bankName}
      beneficiaryName={SHMOKH_NAME[language]}
      accountNumber={accountNumber}
      totalDeals={totalDeals}
      amount={amount}
      currency={currency}
      month={periodLabel}
    />
  );
};

export default RebateCancellationPrint;
